import * as Yup from 'yup';
import { getSeaLinkBasename } from 'utils/helpers';

export const handleLoginSucceedRedirect = (successRedirectURL, history) => {
  const basename = getSeaLinkBasename();

  if (successRedirectURL) {
    window.location.href = `/${basename}/${successRedirectURL}`;
    return;
  }

  // Go back if user comes from sealink pages
  if (
    history.length > 1 &&
    document.referrer.includes(`${window.location.origin}/${basename}`)
  ) {
    return history.goBack();
  }

  // Redirect to 'My account' page
  window.location.assign(`/${basename}/account`);
};

export const formSchema = Yup.object().shape({
  username: Yup.string().required('Username or Email is required'),
  password: Yup.string().required('Password is required'),
});
